const getJsonFromScriptTag = (selector, element) => {
  const scriptEl = element ? element.querySelector(selector) : document.querySelector(selector);
  if (!scriptEl || scriptEl.nodeName !== 'SCRIPT') return null;
  const htmlString = scriptEl.innerHTML.trim().replace(/(\r\n|\n|\r)/gm, '');
  return JSON.parse(htmlString);
};
export default getJsonFromScriptTag;
